import React from 'react';
import {
  BrowserRouter as Router,
  Route,
  Switch,
} from 'react-router-dom';
import Grid from '@material-ui/core/Grid';
import SignInPage from '../SignInPage/SignInPage';
import PasswordForgetPage from '../PasswordForgetPage/PasswordForgetPage';
import DashboardPage from '../DashboardPage/DashboardPage';
import AccountPage from '../AccountPage/AccountPage';
import PasswordChangePage from '../PasswordChangePage/PasswordChangePage';
import withAuthentication from '../../hoc/withAuthentication';
import * as routes from '../../constants/routes';
import NotFoundPage from '../NotFoundPage/NotFoundPage';
import EditProfilePage from '../EditProfilePage/EditProfilePage';
import RentersPage from '../RentersPage/RentersPage';
import RenterPage from '../RenterPage/RenterPage';
import BikesPage from '../BikesPage/BikesPage';
import AddRenterPage from '../AddRenterPage/AddRenterPage';
import AddBikePage from '../BikesPage/AddBikePage';
import EditBikePage from '../BikesPage/EditBikePage';
import SitesPage from '../SitesPage/SitesPage';
import AddSitePage from '../SitesPage/AddSitePage';
import EditRenterPage from '../EditRenterPage/EditRenterPage';
import RentsPage from '../RentsPage/RentsPage';
import EditSitePage from '../SitesPage/EditSitePage';
import InviteRenterPage from '../InviteRenterPage/InviteRenterPage';
import KobooSnackBar from '../../components/Layout/KobooSnackBar';
import UsersPage from '../UsersPage/UsersPage';
import VouchersPage from '../VouchersPage/VouchersPage';
import AddVouchersPage from '../VouchersPage/AddVouchersPage';
import EditVouchersPage from '../VouchersPage/EditVouchersPage';
import BookingsPage from '../Bookings/BookingsPage';
import BookingsLldPage from '../BookingsLld/BookingsLldPage';
import RentLLDPage from '../RentLLDPage/RentLLDPage';
import FeedbacksPage from '../FeedbacksPage/FeedbacksPage';

const App = () =>
  <Router>
    <div>
      <Grid container justifyContent="center">
        <KobooSnackBar />
        <Switch>
          <Route exact path={routes.DASHBOARD} component={DashboardPage} />
          <Route exact path={routes.RENTS} component={RentsPage} />
          <Route exact path={routes.USERS} component={UsersPage} />
          <Route exact path={routes.RENTERS} component={RentersPage} />
          <Route exact path={routes.RENTER_ADD} component={AddRenterPage} />
          <Route exact path={routes.RENTER_EDIT} component={EditRenterPage} />
          <Route exact path={routes.RENTER} component={RenterPage} />
          <Route exact path={routes.SITES} component={SitesPage} />
          <Route exact path={routes.SITE_ADD} component={AddSitePage} />
          <Route exact path={routes.SITE} component={EditSitePage} />
          <Route exact path={routes.BIKES} component={BikesPage} />
          <Route exact path={routes.BIKE_ADD} component={AddBikePage} />
          <Route exact path={routes.BIKE} component={EditBikePage} />
          <Route exact path={routes.VOUCHERS} component={VouchersPage} />
          <Route exact path={routes.VOUCHERS_ADD} component={AddVouchersPage} />
          <Route exact path={routes.VOUCHERS_EDIT} component={EditVouchersPage} />
          <Route exact path={routes.ACCOUNT} component={AccountPage} />
          <Route exact path={routes.EDIT_PROFILE} component={EditProfilePage} />
          <Route exact path={routes.PASSWORD_CHANGE} component={PasswordChangePage} />
          <Route exact path={routes.SIGN_IN} component={SignInPage} />
          <Route exact path={routes.PASSWORD_FORGET} component={PasswordForgetPage} />
          <Route exact path={routes.INVITE_RENTER} component={InviteRenterPage} />
          <Route exact path={routes.BOOKINGS} component={BookingsPage} />
          <Route exact path={routes.BOOKINGS_LLD} component={BookingsLldPage} />
          <Route exact path={routes.RENT_LLD} component={RentLLDPage} />
          <Route exact path={routes.FEEDBACKS} component={FeedbacksPage} />
          <Route render={props => <NotFoundPage {...props} />} />
        </Switch>
      </Grid>
    </div>
  </Router>;

export default withAuthentication(App);



// WEBPACK FOOTER //
// ./src/containers/App/App.jsx